/**
 * This mapping is the same as the values in:
 * web/app/plugins/geo-pages/includes/class-geo-pages-utilities.php::map_id_to_caretype_url
 */
const care_types = [
  ["2", "assisted-living"],
  ["8", "continuing-care"],
  ["10", "alzheimers-care"],
  ["12", "independent-living"],
  ["19", "55-lifestyles"],
  ["20", "homecare"],
  ["22", "low-income-senior-housing"],
  ["23", "respite-care"],
];

export default care_types;

export const idFromCareType = findId => care_types.find(([, findId]) => findId === findId)[0];

export const careTypeFromId = findCareType => care_types.find(([id]) => id === findCareType)[1];

/**
 * Converts searchInput into location breadcrumb.
 *
 * If the formatting logic is changed here, you must also update it in:
 * web/app/plugins/geo-pages/admin/js/geo-pages-admin.js:renderLocationInput
 *
 * @param {string} searchInput - the location to search for
 * @returns {string} searchInput converted into breadcrumb_location
 */
export function searchFormatter(searchInput) {
  if (searchInput.match(/\d{5}/)) {
    searchInput = searchInput.split(", ")[0];
  } else if (searchInput.startsWith("tel:")) {
    searchInput = "";
  } else {
    searchInput = searchInput.replace(", ", "_");
    searchInput = searchInput.replace("'", "");
    searchInput = searchInput.replace(/ /g, "-").toLowerCase();
  }
  return searchInput;
}
